// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.trip-survey {
    display: flex;
    justify-content: space-between;
    gap: 20px;
    padding: 20px;
    background-color: #f9f9f9;
    border: 1px solid #ddd;
    border-radius: 10px;
  }
  
  .interests {
    flex: 1 1;
    background-color: #e8f5e9;
    padding: 20px;
    border-radius: 10px;
  }
  
  .interests h2 {
    color: #004d00;
    margin-bottom:1rem;
  }
  
  .interests ul {
    list-style: none;
    padding: 0;
  }
  
  .interests li {
    margin-bottom: 1rem;
    display: flex;
    align-items: center;
    font-size:1.2rem;
  }

  .interests input[type="checkbox"] {
    margin-right: 10px;
  }
  
  .form-section {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  
  .form-group {
    display: flex;
    flex-direction: column;
    position: relative;
  }
  
  .form-group label {
    margin-bottom: 5px;
  }
  
  .form-group input {
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 5px;
  }

  .message-textarea {
    min-height: 100px;
    width: 100%;
    resize: vertical;
    padding: 10px;
    font-family: inherit;
    line-height: 1.5;
    border: 1px solid #ddd;
    border-radius: 5px;
    margin-top: 5px;
  }
    
  button[type="submit"] {
    width: auto;
    margin-top: 20px;
    font-size: 1.2rem;
    padding: 10px;
  }

  /* Date input styles */
  .form-group input[type="date"] {
    -webkit-appearance: none;
    -webkit-min-logical-width: calc(100% - 16px);
    position: relative;
    background-color: #f9f9f9;
    padding-right: 30px; /* Make room for the icon */
  }

  .date-icon {
    position: absolute;
    right: 10px;
    top: calc(50% + 10px); /* Adjust to align with input field */
    transform: translateY(-50%);
    width: 16px;
    height: 16px;
    pointer-events: none;
    color: #666;
    z-index: 2;
  }

  .form-group input[type="date"]::-webkit-calendar-picker-indicator {
    opacity: 0; /* Hide the default calendar icon */
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    cursor: pointer;
    z-index: 1;
  }

  /* 태블릿: max-width 1024px */

  /* 모바일: max-width 768px */
  @media (max-width: 768px) {
    .trip-survey {
      flex-direction: column;
      gap: 15px;
    }
  
    .interests ul {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
    }
  
    .interests li {
      flex-grow: 1;
      flex-shrink: 1;
      flex-basis: calc(33.3% - 10px); /* Maintain three items per row */
      font-size: 1rem;
    }
  
    .form-section {
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
      gap: 1rem;
    }
  
    .form-group {
      display: flex;
      flex-direction: column;
      width: 100%;
      margin-bottom: 1rem;

    }
  
    .form-group label {
      margin-bottom: 5px;
    }
  
    .form-group input {
      width: 100%;
      padding: 10px;
    }
  
    button[type="submit"] {
      width: auto;
      margin-top: 20px;
    }
  }
  
  /* 작은 모바일: max-width 480px */
@media (max-width: 480px) {
  .trip-survey {
    flex-direction: column;
    gap: 10px;
    padding: 10px 20px;
  }

  .interests {
    padding: 15px;
  }

  .interests li {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(33.333% - 10px); 
    font-size: 0.9rem;
  }

  .form-section {
    order: 2;
  }

  .interests {
    order: 1; 
  }

  .form-group {
    margin-bottom: 10px;
  }

  .form-group input {
    padding: 8px;
    width: 100%;
  }

  button[type="submit"] {
    width: -moz-fit-content;
    width: fit-content;
    margin: 10px;
    padding: 12px;
    font-size: 0.9rem;
    align-self: flex-end;
    
  }


}`, "",{"version":3,"sources":["webpack://./src/assets/styles/tripSurvey.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,SAAO;IACP,yBAAyB;IACzB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,oBAAoB;IACpB,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;EACf;;EAEA,sBAAsB;EACtB;IACE,wBAAwB;IACxB,4CAA4C;IAC5C,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB,EAAE,2BAA2B;EAClD;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,qBAAqB,EAAE,qCAAqC;IAC5D,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,UAAU,EAAE,mCAAmC;IAC/C,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,eAAe;IACf,UAAU;EACZ;;EAEA,0BAA0B;;EAE1B,yBAAyB;EACzB;IACE;MACE,sBAAsB;MACtB,SAAS;IACX;;IAEA;MACE,aAAa;MACb,eAAe;MACf,SAAS;IACX;;IAEA;MACE,YAA4B;MAA5B,cAA4B;MAA5B,8BAA4B,EAAE,iCAAiC;MAC/D,eAAe;IACjB;;IAEA;MACE,aAAa;MACb,eAAe;MACf,sBAAsB;MACtB,SAAS;IACX;;IAEA;MACE,aAAa;MACb,sBAAsB;MACtB,WAAW;MACX,mBAAmB;;IAErB;;IAEA;MACE,kBAAkB;IACpB;;IAEA;MACE,WAAW;MACX,aAAa;IACf;;IAEA;MACE,WAAW;MACX,gBAAgB;IAClB;EACF;;EAEA,4BAA4B;AAC9B;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAA8B;IAA9B,cAA8B;IAA9B,gCAA8B;IAC9B,iBAAiB;EACnB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,uBAAkB;IAAlB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,oBAAoB;;EAEtB;;;AAGF","sourcesContent":[".trip-survey {\n    display: flex;\n    justify-content: space-between;\n    gap: 20px;\n    padding: 20px;\n    background-color: #f9f9f9;\n    border: 1px solid #ddd;\n    border-radius: 10px;\n  }\n  \n  .interests {\n    flex: 1;\n    background-color: #e8f5e9;\n    padding: 20px;\n    border-radius: 10px;\n  }\n  \n  .interests h2 {\n    color: #004d00;\n    margin-bottom:1rem;\n  }\n  \n  .interests ul {\n    list-style: none;\n    padding: 0;\n  }\n  \n  .interests li {\n    margin-bottom: 1rem;\n    display: flex;\n    align-items: center;\n    font-size:1.2rem;\n  }\n\n  .interests input[type=\"checkbox\"] {\n    margin-right: 10px;\n  }\n  \n  .form-section {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 15px;\n  }\n  \n  .form-group {\n    display: flex;\n    flex-direction: column;\n    position: relative;\n  }\n  \n  .form-group label {\n    margin-bottom: 5px;\n  }\n  \n  .form-group input {\n    padding: 10px;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n  }\n\n  .message-textarea {\n    min-height: 100px;\n    width: 100%;\n    resize: vertical;\n    padding: 10px;\n    font-family: inherit;\n    line-height: 1.5;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    margin-top: 5px;\n  }\n    \n  button[type=\"submit\"] {\n    width: auto;\n    margin-top: 20px;\n    font-size: 1.2rem;\n    padding: 10px;\n  }\n\n  /* Date input styles */\n  .form-group input[type=\"date\"] {\n    -webkit-appearance: none;\n    -webkit-min-logical-width: calc(100% - 16px);\n    position: relative;\n    background-color: #f9f9f9;\n    padding-right: 30px; /* Make room for the icon */\n  }\n\n  .date-icon {\n    position: absolute;\n    right: 10px;\n    top: calc(50% + 10px); /* Adjust to align with input field */\n    transform: translateY(-50%);\n    width: 16px;\n    height: 16px;\n    pointer-events: none;\n    color: #666;\n    z-index: 2;\n  }\n\n  .form-group input[type=\"date\"]::-webkit-calendar-picker-indicator {\n    opacity: 0; /* Hide the default calendar icon */\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    cursor: pointer;\n    z-index: 1;\n  }\n\n  /* 태블릿: max-width 1024px */\n\n  /* 모바일: max-width 768px */\n  @media (max-width: 768px) {\n    .trip-survey {\n      flex-direction: column;\n      gap: 15px;\n    }\n  \n    .interests ul {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 10px;\n    }\n  \n    .interests li {\n      flex: 1 1 calc(33.3% - 10px); /* Maintain three items per row */\n      font-size: 1rem;\n    }\n  \n    .form-section {\n      display: flex;\n      flex-wrap: wrap;\n      flex-direction: column;\n      gap: 1rem;\n    }\n  \n    .form-group {\n      display: flex;\n      flex-direction: column;\n      width: 100%;\n      margin-bottom: 1rem;\n\n    }\n  \n    .form-group label {\n      margin-bottom: 5px;\n    }\n  \n    .form-group input {\n      width: 100%;\n      padding: 10px;\n    }\n  \n    button[type=\"submit\"] {\n      width: auto;\n      margin-top: 20px;\n    }\n  }\n  \n  /* 작은 모바일: max-width 480px */\n@media (max-width: 480px) {\n  .trip-survey {\n    flex-direction: column;\n    gap: 10px;\n    padding: 10px 20px;\n  }\n\n  .interests {\n    padding: 15px;\n  }\n\n  .interests li {\n    flex: 1 1 calc(33.333% - 10px); \n    font-size: 0.9rem;\n  }\n\n  .form-section {\n    order: 2;\n  }\n\n  .interests {\n    order: 1; \n  }\n\n  .form-group {\n    margin-bottom: 10px;\n  }\n\n  .form-group input {\n    padding: 8px;\n    width: 100%;\n  }\n\n  button[type=\"submit\"] {\n    width: fit-content;\n    margin: 10px;\n    padding: 12px;\n    font-size: 0.9rem;\n    align-self: flex-end;\n    \n  }\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
